function space (length) {
  let space = ''

  for (let i = 0; i < length; i++) {
    space += ' '
  }

  return space
}

export default space
